import React, { useState } from 'react';
import './TweetBox.css';
import { Avatar, Button } from '@material-ui/core';
import db from './firebase';

function TweetBox() {
  const [tweetMessage, setTweetMessage] = useState('');
  const [tweetImage, setTweetImage] = useState('');
  let id = 0;

  db.collection('posts')
    .get()
    .then(snap => {
      id = snap.size + 1;
    });

  const sendTweet = e => {
    e.preventDefault();

    if (
      (tweetMessage && ![...tweetMessage].every(x => x === ' ')) ||
      (tweetImage && ![...tweetImage].every(x => x === ' '))
    ) {
      db.collection('posts').add({
        id: id,
        displayName: 'Follow Bheart',
        username: '@ShresthaBheart',
        verified: true,
        text: tweetMessage,
        image: tweetImage,
        avatar:
          'https://yt3.ggpht.com/-eFr4O0tRi9I/AAAAAAAAAAI/AAAAAAAAAAA/jNcYoSbTahE/s108-c-k-c0x00ffffff-no-rj-mo/photo.jpg',
        liked: false,
      });
    }
    setTweetMessage('');
    setTweetImage('');
  };

  return (
    <div className='tweetBox'>
      <form>
        <div className='tweetBox__input'>
          <Avatar src='https://yt3.ggpht.com/-eFr4O0tRi9I/AAAAAAAAAAI/AAAAAAAAAAA/jNcYoSbTahE/s108-c-k-c0x00ffffff-no-rj-mo/photo.jpg' />

          <input
            onChange={e => setTweetMessage(e.target.value)}
            value={tweetMessage}
            placeholder="What's happening?"
            type='text'
          />
        </div>
        <input
          onChange={e => setTweetImage(e.target.value)}
          value={tweetImage}
          className='tweetBox__imageInput'
          placeholder='Optional: Enter image URL'
          type='text'
        />
        <Button
          onClick={sendTweet}
          type='submit'
          className='tweetBox__tweetButton'>
          Tweet
        </Button>
      </form>
    </div>
  );
}

export default TweetBox;
